// Yaw that turns a speaker's facing axis (local +Z) toward a target position
// (typically the listener). Single source of truth for this: it used to live
// only in packages/room-flow (which re-exports it from here now, unchanged
// for its own callers), but the SYNC_TRANSFORM reducer case in
// editorState.ts needs it directly for "a speaker stays pointed at the
// listener while it's moved" (SpeakerEntry.faceListener), and core can't
// depend on room-flow (room-flow depends on core).

import type { Vec3 } from './adminTypes';

export function faceToward(pos: Vec3, target: Vec3 | null | undefined): number {
  if (!target) return 0;
  const dx = target[0] - pos[0], dz = target[2] - pos[2];
  if (dx === 0 && dz === 0) return 0;
  return Math.atan2(dx, dz);
}
